module.exports = __webpack_public_path__ + "app/images/bw/favicon.bw.png";